import { MigrationConfig } from './utils/migration';

export const migrationConfigs: MigrationConfig[] = [
  {
    localKey: 'ForYouNotificationFilters',
    prefId: 'ForYouNotificationFilters',
    transform: (value) => value.state.forYouNotificationFilters,
  },
];
